import type { UiNode } from '@ory/client';

import { useNodeTranslation } from '@/features/auth/hooks/useNodeTranslation';

type Props = {
  node: UiNode;
};

/**
 * Imageノードコンポーネント
 *
 * Ory KratosのServer Driven UIで返されるimageノードをレンダリングします。
 * 主にTOTP（Time-based One-Time Password）のQRコードなどに使用されます。
 *
 * @see https://www.ory.com/docs/kratos/concepts/ui-user-interface#ui-image-nodes
 */
export function ImageNode({ node }: Props) {
  const { translateUiText } = useNodeTranslation();

  // imgノードでない場合は何もレンダリングしない
  if (node.type !== 'img') {
    return null;
  }

  const attrs = node.attributes as {
    src?: string;
    id?: string;
    width?: number | string;
    height?: number | string;
    node_type?: string;
  };

  // srcが存在しない場合は何もレンダリングしない
  if (!attrs.src) {
    return null;
  }

  // meta.labelがあれば翻訳してalt属性として使用
  const alt = node.meta?.label ? translateUiText(node.meta.label) : undefined;

  return (
    <img
      src={attrs.src}
      id={attrs.id}
      alt={alt}
      width={attrs.width}
      height={attrs.height}
      className="mx-auto"
    />
  );
}
